import React from 'react';
import Steps from './Steps';
import { Formik, Form, Field , ErrorMessage } from "formik";
import { userContext } from '../../../context/usercontext';
import { useContext, useState , useEffect } from 'react';
import { getAllZones,getAllCategory } from '../../../services/kojaServices';
import { estateInfoSchema } from '../../../validation/validation';
import Header from '../menu/Header';
import Menu from '../menu/Menu';
import Mapir from "mapir-react-component";
import 'mapir-react-component/dist/index.css';

const Map = Mapir.setToken({
  transformRequest: url => {
    return {
      url: url,
      headers: {
        "x-api-key":" eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjNmY2JhMTA0ODliNzg1YzllZTIwOWEyMWUzMThkZTFiM2ZhNGYzMzdmMWM5N2M0MmI2ZjAzZTlmOTY1NTRjMmIwYWQ3NmUzOGIyZWNmOTgwIn0.eyJhdWQiOiIyMjE4MyIsImp0aSI6IjNmY2JhMTA0ODliNzg1YzllZTIwOWEyMWUzMThkZTFiM2ZhNGYzMzdmMWM5N2M0MmI2ZjAzZTlmOTY1NTRjMmIwYWQ3NmUzOGIyZWNmOTgwIiwiaWF0IjoxNjgzNTM1Nzc1LCJuYmYiOjE2ODM1MzU3NzUsImV4cCI6MTY4NjEyNzc3NSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.ri9BQ1JndqoWxqOLOFsHmc-yPLkG2XzNJngBjYTHibzF5qtDdCBxFg6-NgQAdLp07D994YnYfya5mzWR3uht41n7kGVW0OcmuQen6ytHMGfio0GmwjXN8Y_oQL1uznh3EYiBq5Srb2_MnXj_c6vuWpdiuhhRt_O8Da_tbewL-QBM-so2J1P1oKh1DO7hCo1AoK99VjSBSnEYogokfvZa1ISNERrAP-5RXQXijJCRMB6PrC04mqK35hle9tc2o-dUFoZOJcdNUZsYP3_Fot0ejxy6b8pkJRhJ_ZN3d_9wYUoFXBPzjEZExNd06esESebEtDNIE7RxJ_7fuE8v-gl9mA", 
        "Mapir-SDK": "reactjs"
      }
    };
  }
});

const EstateInfo = () => {

    const {estateInfo,setEstateInfo,setRequestStep} = useContext(userContext)
    const [zones,setZones] = useState([]);
    const [category,setCategory] = useState([])
    const [coord, setCoord] = useState();

    function reverseFunction(map, e,setFieldValue) {
      var url = `https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${
        e.lngLat.lng
      }`;
      fetch(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjNmY2JhMTA0ODliNzg1YzllZTIwOWEyMWUzMThkZTFiM2ZhNGYzMzdmMWM5N2M0MmI2ZjAzZTlmOTY1NTRjMmIwYWQ3NmUzOGIyZWNmOTgwIn0.eyJhdWQiOiIyMjE4MyIsImp0aSI6IjNmY2JhMTA0ODliNzg1YzllZTIwOWEyMWUzMThkZTFiM2ZhNGYzMzdmMWM5N2M0MmI2ZjAzZTlmOTY1NTRjMmIwYWQ3NmUzOGIyZWNmOTgwIiwiaWF0IjoxNjgzNTM1Nzc1LCJuYmYiOjE2ODM1MzU3NzUsImV4cCI6MTY4NjEyNzc3NSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.ri9BQ1JndqoWxqOLOFsHmc-yPLkG2XzNJngBjYTHibzF5qtDdCBxFg6-NgQAdLp07D994YnYfya5mzWR3uht41n7kGVW0OcmuQen6ytHMGfio0GmwjXN8Y_oQL1uznh3EYiBq5Srb2_MnXj_c6vuWpdiuhhRt_O8Da_tbewL-QBM-so2J1P1oKh1DO7hCo1AoK99VjSBSnEYogokfvZa1ISNERrAP-5RXQXijJCRMB6PrC04mqK35hle9tc2o-dUFoZOJcdNUZsYP3_Fot0ejxy6b8pkJRhJ_ZN3d_9wYUoFXBPzjEZExNd06esESebEtDNIE7RxJ_7fuE8v-gl9mA"
        }
      })
        .then(response => response.json())
        .then(data => console.log(data));
        let lat = e.lngLat.lat;
        let lng = e.lngLat.lng;
        setFieldValue("lat", lat);
        setFieldValue("lng", lng);
        setCoord([lng,lat])
    }

    const nextStep = (values)=>{
      setRequestStep(2)
      setEstateInfo(values)
      // console.log(values)
  }

    useEffect(() => {
        const fetchData = async () => {
          try {
            const { data:zones } = await getAllZones();
            // console.log(zones);
            setZones(zones.result)
            const { data:category } = await getAllCategory();
            // console.log(category);
            setCategory(category.result)
            if(estateInfo.lat){
              setCoord([estateInfo.lng,estateInfo.lat])
            }
          } catch (err) {
            console.log(err);
          }
        };
        fetchData();
      }, []);

    return (
      <div className='expertRequest'>
      <Header/>
      <div className='d-flex request-box-content' style={{margin:"20px 30px 0px 30px"}}>
      <Menu/>
      <div className='w-100 m-1'>
      <Steps step={1}/>
      <div className='text-end m-4'>
      <Formik 
      initialValues={{
          ExZoneId: estateInfo.ExZoneId || "",
          ExCategoryId: estateInfo.ExCategoryId || "",
          lat: estateInfo.lat || "",
          lng: estateInfo.lng || "",
          address: estateInfo.address || "",
        }}
        validationSchema={estateInfoSchema}
        onSubmit={(values , {resetForm}) => {
        nextStep(values)
        }}
        enableReinitialize={true}
      >
      {({
        isSubmitting,
        errors,
        setFieldValue,
        touched,
      }) => ( 
          <Form>
          <div className="row  align-items-center ">
          <div className='col-md-6'>
          <div className="mb-3 col-12 col-xl-10">
          <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name">منطقه : </label>
          <Field
          name="ExZoneId"
          as="select"
          className="w-100 request-form-input"
        >
        <option>لطفا یک گزینه انتخاب کنید</option>
        {
          zones.map((s,index)=>(
            <option key={index} value={s.id}>{s.name}</option>
          ))
         }
        </Field>
        <ErrorMessage
          name="ExZoneId"
          render={(msg) => (
            <div className="text-danger">{msg}</div>
          )}
        />
          </div>
          <div className="mb-3 col-12 col-xl-10">
          <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name">نوع ملک : </label>
          <Field
          name="ExCategoryId"
          as="select"
          className="w-100 request-form-input"
        >
        <option>لطفا یک گزینه انتخاب کنید</option>
        {
          category.map((s,index)=>(
            <option key={index} value={s.id}>{s.name}</option>
          ))
         }
        </Field>
        <ErrorMessage
          name="ExCategoryId"
          render={(msg) => (
            <div className="text-danger">{msg}</div>
          )}
        />
          </div>
          <div className="mb-3 col-12 col-xl-10">
          <label className="mb-1 ms-2 d-flex label-form request-form-label" htmlFor="name"> آدرس : </label>
          <Field
          name="address"
          as='textarea'
          className="w-100 request-form-input px-5 text-break"
          style={{height :"120px", resize:"none"}}
        />
        <ErrorMessage
          name="address"
          render={(msg) => (
            <div className="text-danger">{msg}</div>
          )}
        />
          </div>
          </div>
          <div className='col-md-6 '>
             <Mapir 
          center={coord || [51.365459,32.633116]} 
          Map={Map}
          className="request-map"
          onClick={(map, element) =>  reverseFunction(map, element, setFieldValue) }
          interactive={false}
        
          >
          <Mapir.Marker coordinates={coord} anchor="bottom" />
          </Mapir>
          <ErrorMessage
          name="lat"
          render={(msg) => (
            <div className="text-danger">{msg}</div>
          )}
        />
          </div>
          </div>
          <div className='d-flex justify-content-between'>
          <div className=' request-next-btn-box'>
          <button className='btn request-next-btn' type='submit'>بعدی</button>
          </div>
          <div className=' request-Previous-btn-box invisible'>
          <button className='btn request-Previous-btn'>قبلی</button>
          </div>
          </div>
          </Form> )}
          </Formik>
      </div>
          
      </div>
      </div>
      </div>
    );
};

export default EstateInfo;